/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRightToArc = createReactComponent("outline", "arrow-right-to-arc", "IconArrowRightToArc", [["path", { "d": "M3 12h12", "key": "svg-0" }], ["path", { "d": "M11 8l4 4l-4 4", "key": "svg-1" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-2" }]]);

export { IconArrowRightToArc as default };
//# sourceMappingURL=IconArrowRightToArc.mjs.map
